// @ts-nocheck
import {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import {FaFire, FaRegCalendar, FaTrophy} from "react-icons/fa";
import {MdGpsFixed} from "react-icons/md";
import {BaseTabs, BaseTooltip} from "@/components";
import BetbyWidgetFreePlay from "./BetbyWidgetFreePlay";
import BetbyWidgetHotCombos from "./BetbyWidgetHotCombos";
import BetbyWidgetPromo from "./BetbyWidgetPromo";
import BetbyWidgetTopOutrights from "./BetbyWidgetTopOutrights";

const widgetContainerCls = "w-full min-h-[var(--size-50)]";
const widgetTabsCls =
  "mb-2 [&_.ant-tabs-tab]:text-white/70 [&_.ant-tabs-tab]:text-sm [&_.ant-tabs-tab]:font-medium [&_.ant-tabs-tab]:transition-all [&_.ant-tabs-tab]:duration-300 [&_.ant-tabs-tab]:min-w-[var(--size-10)] [&_.ant-tabs-tab]:flex [&_.ant-tabs-tab]:justify-center [&_.ant-tabs-tab]:items-center hover:[&_.ant-tabs-tab]:text-white/90 hover:[&_.ant-tabs-tab]:-translate-y-px [&_.ant-tabs-tab-active]:text-[var(--color-text)]! [&_.ant-tabs-tab-active_.ant-tabs-tab-btn]:text-[var(--color-text)]! [&_.ant-tabs-tab-active_.ant-tabs-tab-btn_span]:text-[var(--color-text)]! [&_.ant-tabs-tab-active_span]:text-[var(--color-text)]! [&_.ant-tabs-tab-active_span]:font-semibold [&_.ant-tabs-tab_span]:flex [&_.ant-tabs-tab_span]:items-center [&_.ant-tabs-tab_span]:justify-center [&_.ant-tabs-tab_span]:gap-1.5 [&_.ant-tabs-tab_span]:min-h-[var(--size-6)] [&_.ant-tabs-tab_svg]:block [&_.ant-tabs-ink-bar]:bg-gradient-to-r [&_.ant-tabs-ink-bar]:from-[var(--color-primary)] [&_.ant-tabs-ink-bar]:to-[var(--color-primary-soft)] [&_.ant-tabs-ink-bar]:h-[3px] [&_.ant-tabs-ink-bar]:rounded-[var(--radius-sm)] [&_.ant-tabs-nav]:mb-4 [&_.ant-tabs-nav::before]:border-b [&_.ant-tabs-nav::before]:border-white/10 [&_.ant-tabs-content-holder]:p-0";

const labelStyle = {
  fontSize: "var(--font-body-lg)",
  fontWeight: "500",
  display: "flex",
  alignItems: "center",
  gap: "var(--space-2)",
};

const BetbyWidgetContainer = () => {
  const {t} = useTranslation();
  const [activeTab, setActiveTab] = useState("top_match");

  const handleTabChange = useCallback(newActiveKey => {
    setActiveTab(newActiveKey);
  }, []);

  const renderLabel = (key, text, Icon) =>
    activeTab === key ? (
      <span style={labelStyle}>{text}</span>
    ) : (
      <BaseTooltip
        title={text}
        placement="bottom"
      >
        <span style={labelStyle}>
          <Icon size={16} />
        </span>
      </BaseTooltip>
    );

  const widgetTabs = [
    {
      key: "top_match",
      label: renderLabel("top_match", t("topEvents", "Top Events"), MdGpsFixed),
      children: activeTab === "top_match" ? <BetbyWidgetFreePlay key="top_match" /> : null,
    },
    {
      key: "hot_combos",
      label: renderLabel("hot_combos", t("hotCombos", "Hot Combos"), FaFire),
      children: activeTab === "hot_combos" ? <BetbyWidgetHotCombos key="hot_combos" /> : null,
    },
    {
      key: "top_outrights",
      label: renderLabel("top_outrights", t("topOutrights", "Top Outrights"), FaRegCalendar),
      children: activeTab === "top_outrights" ? <BetbyWidgetTopOutrights key="top_outrights" /> : null,
    },
    {
      key: "promo",
      label: renderLabel("promo", t("promoTournament", "Promo Tournament"), FaTrophy),
      children: activeTab === "promo" ? <BetbyWidgetPromo key="promo" /> : null,
    },
  ];

  return (
    <div className={widgetContainerCls}>
      <BaseTabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={widgetTabs}
        className={widgetTabsCls}
      />
    </div>
  );
};

export default BetbyWidgetContainer;
